import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import '@shared/styles/index.css';
import { ReactComponent as SearchSVG } from '@shared/assets/SVGs/PresenteeismTable/SearchSVG.svg';
import { TextInput, TextInputRef } from './TextInput';
import designSystem from '@shared/styles/designSystemStyles';
import { HorizontalContainer } from './Containers';

interface SearchBarProps {
	placeholder?: string
    value?: string
	onChange: (e: string) => void
    className?: string
    disabled?: boolean
    width?: string
}

export interface SearchBarRef {
    focus: () => void
}

const SearchBar = forwardRef<SearchBarRef, SearchBarProps>(({ placeholder = '...', value, onChange, className, disabled = false, width}, ref) => {
    const inputRef = useRef<TextInputRef>(null)

    useImperativeHandle(ref, () => ({
        focus: () => {
            inputRef.current?.focus()
        }
    }))

	return (
        <HorizontalContainer width={width ?? '100%'} justifyContent="flex-start">
            <TextInput
                ref={inputRef}
                className={['DSSearchBar', className].filter(Boolean).join(' ')}
                icon={<SearchSVG style={{ width: designSystem.sizeIconWidth, height: designSystem.sizeIconHeight }} />}
                label=''
                placeholder={placeholder}
                onChange={onChange}
                value={value}
                loading={false}
                disabled={disabled}
                width="100%"
            />
        </HorizontalContainer>
	);
});

SearchBar.displayName = 'SearchBar';

export default SearchBar;
